import type {HTMLAttributes} from 'react'
import {resolveFitroContentImageSources} from '@fitro/rich-content'
import {cn} from './cn'

interface RichContentProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
    html: string
    assetBaseUrl?: string | null
}

/** Renders canonical HTML sanitized by the backend content boundary. */
export function RichContent({html, assetBaseUrl, className, ...props}: RichContentProps) {
    const resolvedHtml = resolveFitroContentImageSources(html, assetBaseUrl)
    return (
        <div
            {...props}
            className={cn(
                '[&>:first-child]:mt-0 [&>:last-child]:mb-0 fitro-rich-content text-sm leading-6 text-gray-700 dark:text-gray-200',
                '[&_a]:text-primary-700 [&_a]:underline [&_a]:underline-offset-2 dark:[&_a]:text-primary-300',
                '[&_blockquote]:my-3 [&_blockquote]:border-l-4 [&_blockquote]:border-gray-300 [&_blockquote]:pl-3 [&_blockquote]:italic dark:[&_blockquote]:border-gray-600',
                '[&_h1]:mb-2 [&_h1]:mt-4 [&_h1]:text-xl [&_h1]:font-bold',
                '[&_h2]:mb-2 [&_h2]:mt-4 [&_h2]:text-lg [&_h2]:font-semibold',
                '[&_h3]:mb-2 [&_h3]:mt-3 [&_h3]:font-semibold',
                '[&_li]:my-1 [&_ol]:my-3 [&_ol]:list-decimal [&_ol]:pl-5 [&_p+p]:mt-3 [&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-5',
                className
            )}
            dangerouslySetInnerHTML={{__html: resolvedHtml}}
        />
    )
}
